module.exports = __webpack_public_path__ + "img/lx.a18635c5.jpg";